import Vue from "vue";
import { getAccessToken } from "@/common/storage";
import { EOS_BASE_URL } from "@/common/config";
import {
  addExternalMapLayerToMap,
  backToPrevPage,
  closeContentPage,
  openContentPage,
  openCountryPage,
  openHomePage,
  openLatestPage,
} from "@/common/eos.utilities";

export default {
  install(Vue, options) {
    // Add the event listener when the plugin is installed
    window.addEventListener("message", handleMessageEvent);
  },
};

/**
 * `eos` has the ability to publish messages to the browser that the main `seerist` app has access to
 *
 * we will be using this feature to handle navigation requests from within the frame, rather than changing the url
 * the `eos` app will publish a browser message that seerist listens for which triggers navigation
 *
 * any unhanlded events will be emitted, use `return` to prevent emits and `break` to allow emit after execution
 *
 * the payload from Eos can be accessed via `event.data` and the expected structure is typed `{ event: string; state: any; }`
 *
 * @param {String} `event` an action key to help make decisions
 * @param {Any} `state` any object that needs to be passed between apps, structure will be dependent on key passed
 */
async function handleMessageEvent({ data: { event, state } }) {
  switch (event) {
    case "copy":
      await navigator.clipboard.writeText(state);
      return;
    // Goes back to prev as per history
    case "back":
      backToPrevPage();
      return;
    // Closes current selector panel
    case "close":
      await closeContentPage();
      return;
    // Navigate to home/landing page based on user's pref
    case "home":
      await openHomePage();
      return;
    case "open.latest":
      await openLatestPage();
      return;
    case "open.country":
      await openCountryPage(state);
      return;
    case "open.article":
      await openContentPage(`/news/${state}`, { event, state });
      return;
    case "open.breaking-event":
      await openContentPage(`/breaking-events/${state}`, {
        event,
        state,
      });
      return;
    case "open.future-event":
      await openContentPage(`/future-events/${state}`, {
        event,
        state,
      });
      return;
    case "open.verified-event":
      await openContentPage(`/verified-events/security/${state}`, {
        event,
        state,
      });
      return;
    case "open.analysis":
      await openContentPage(`/analysis/${state}`, { event, state });
      return;
    case "open.headline":
      await openContentPage(`/discover/headlines/${state}`, { event, state });
      return;
    case "open.headline-articles":
      await openContentPage(`/headlines/articles/${state}`, { event, state });
      return;
    case "open.externallink":
      this.sourceLink = state;
      this.showSourceLink = new Date().toISOString();
      return;
    case "add.externalmaplayer":
      addExternalMapLayerToMap(state);
      break;
    case "open.newscluster":
      await openContentPage(`/newscluster/${state}`, { event, state });
      return;
  }
}
